import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { translations } from "./translations";
import { isSpanishOnly, localizePath, parsePath } from "./seo/routes";

const LanguageContext = createContext(null);

const KEY_MAP = { ES: "es", EN: "en", PT: "pt" };

// El idioma sale de la URL (/en, /pt o sin prefijo = ES). El blog es solo en
// español, así que ahí se conserva el idioma con el que venía navegando el usuario.
export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang: urlLang, esPath } = parsePath(location.pathname);
  const neutral = isSpanishOnly(esPath);
  const [sticky, setSticky] = useState(urlLang || "ES");

  useEffect(() => {
    if (!neutral) setSticky(urlLang || "ES");
  }, [urlLang, neutral]);

  const lang = neutral ? sticky : urlLang || "ES";

  useEffect(() => {
    document.documentElement.lang = KEY_MAP[lang];
  }, [lang]);

  const setLang = (next) => {
    window.localStorage.setItem("bm_lang", next);
    if (neutral) setSticky(next);
    else navigate(`${localizePath(esPath, next)}${location.search}${location.hash}`);
  };

  const lp = (to) => localizePath(to, lang);
  const t = translations[KEY_MAP[lang]];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, lp, esPath }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
